export default "__VITE_ASSET__df126b47__"